export const ticketLabelAvailable = [
  {
    label: "vip1",
    id: "vip1",
    color: "#27A8DF",
  },
  {
    label: "vip2",
    id: "vip2",
    color: "#FFF000",
  },
  {
    label: "vip3",
    id: "vip3",
    color: "#EA008A",
  },
  {
    label: "vip4",
    id: "vip4",
    color: "#27A8DF",
  },
  {
    label: "vip2",
    id: "vip2",
    color: "#FFF000",
  },
  {
    label: "vip3",
    id: "vip3",
    color: "#EA008A",
  },
  {
    label: "vip4",
    id: "vip4",
    color: "#27A8DF",
  },
];
